import {AssetSubtypes} from "utils/assets";
import {ENTITY_TYPE} from "utils/entities";

export const isAssetDevice = (value) => value === AssetSubtypes.Device;

export const getWorkflowEntityType = (coaTargetType) =>
  isAssetDevice(coaTargetType) ? ENTITY_TYPE.assets : ENTITY_TYPE.observables;

export const getWorkflowType = (coaTargetType) =>
  isAssetDevice(coaTargetType) ? "hostname" : coaTargetType;

export const getWorkflowEntityData = (entitiesByType, coaTargetType) =>
  entitiesByType?.[getWorkflowEntityType(coaTargetType)]?.[
    getWorkflowType(coaTargetType)
  ];

export const getWorkflowTypeName = (coaTargetType) => {
  const type = getWorkflowType(coaTargetType);

  return isAssetDevice(coaTargetType) || type === "domain"
    ? type
    : type.toUpperCase();
};
